export const BASE_SX = { fontWeight: 400, fontSize: '14px' };
